import React, { useState, useEffect } from 'react';
import { axiosInstance } from '../apis/axiosConfig';
import { useNavigate } from 'react-router-dom';

const PrivilegedData = () => {
  const [privilegedData, setPrivilegedData] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPrivilegedData = async () => {
      try {
        const response = await axiosInstance.get('/api/admin/privileged-data');
        setPrivilegedData(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching privileged data:', err);
        setError('You do not have permission to view this data.');
      }
    };

    fetchPrivilegedData();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      {false && <nav className="bg-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex">
              <div className="flex-shrink-0 flex items-center">
                <img className="h-8 w-auto" src="/logo.png" alt="Company Logo" />
              </div>
            </div>
            <div className="flex items-center">
              <button
                onClick={() => navigate('/dashboard')}
                className="ml-4 px-4 py-2 rounded-md text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Back to Dashboard
              </button>
            </div>
          </div>
        </div>
      </nav>}

      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold text-gray-900">Privileged Data</h1>
        </div>
      </header>

      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              {error ? (
                <div className="text-red-500 text-center">{error}</div>
              ) : privilegedData.length > 0 ? (
                <ul className="space-y-4">
                  {privilegedData.length > 0 && privilegedData.map((item) => (
                    <li key={item._id} className="border p-4 rounded shadow">
                      <h3 className="font-semibold text-lg">{item.title}</h3>
                      <p className="text-gray-600">{item.description}</p>
                      <p className="text-sm text-gray-500 mt-2">Secret Code: {item.secretCode}</p>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-center text-gray-500">No privileged data available.</p>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivilegedData;
